<script setup>
// Екран замість плеєра, коли ефір закритий селектом «Доступ» зі Strapi.
// Способи входу — у LiveLoginButtons: там же вони показуються на екрані
// «офлайн», щоб доступ можна було перевірити ще до початку ефіру.
const props = defineProps({
  access: { type: Object, required: true }
})

// Уже залогінений, але не проходить за статусом — тоді пояснюємо, чому саме
// не пустило (підписку могли щойно оформити й не перезайти)
const loggedInButRejected = computed(
  () => props.access.authenticated && !props.access.allowed
)
</script>

<template>
  <div
    class="flex flex-col justify-center items-center gap-[20px] px-[20px] py-[40px] h-full text-center"
  >
    <p class="font-semibold text-2xl">Ефір закритий</p>

    <p class="opacity-70 max-w-[520px]">
      <template v-if="access.needsTwitch && access.needsMono">
        Дивитися можуть підписники Twitch-каналу
        <a
          href="https://www.twitch.tv/olsior"
          target="_blank"
          class="link"
          >Olsior</a
        >
        або учасники
        <a
          href="https://base.monobank.ua/olsior#subscriptions"
          target="_blank"
          class="link"
          >Монобази</a
        >.
      </template>
      <template v-else-if="access.needsTwitch">
        Дивитися можуть підписники Twitch-каналу
        <a
          href="https://www.twitch.tv/olsior"
          target="_blank"
          class="link"
          >Olsior</a
        >.
      </template>
      <template v-else>
        Дивитися можуть учасники
        <a
          href="https://base.monobank.ua/olsior#subscriptions"
          target="_blank"
          class="link"
          >Монобази</a
        >.
      </template>
    </p>

    <div
      v-if="loggedInButRejected"
      class="opacity-70 text-sm"
    >
      <template v-if="access.twitchLogin">
        Ви увійшли як <b>{{ access.twitchLogin }}</b
        >, але активної підписки не знайдено.
      </template>
      <template v-else>
        Ви увійшли, але потрібної підписки не знайдено.
      </template>
      Оформіть підписку й увійдіть ще раз — статус оновлюється при вході.
    </div>

    <LiveLoginButtons :access="access" />
  </div>
</template>
